import Controller from '@ember/controller';

export default class DatamanagerAvailableController extends Controller {}
